<!-- vue模板 -->
<template>
  <div class="lcltext">
    <el-button class="copy-text-btn" type="primary" @click="copyTextEvent" icon="el-icon-document-copy">一键复制文本</el-button>
    <div class="copy-text-content">
      <div class="lcltext-item">
        <p>业务类型：海出拼箱</p>
        <p>船公司：{{ lclInfo.lclInfo.F_ShoppingCompany ? lclInfo.lclInfo.F_ShoppingCompany : '--' }}</p>
        <p>起运港：{{ lclInfo.lclInfo.FromPortName }} {{ lclInfo.lclInfo.FromPortEnglish }}</p>
        <p>目的港：{{ lclInfo.lclInfo.ToPortName }} {{ lclInfo.lclInfo.ToPortEnglish }}</p>
        <p>航程：{{ lclInfo.lclInfo.F_Voyage }}</p>
        <p>收货人：{{ lclInfo.lclInfo.ConsigneeTypeName }}</p>
        <p>运输方式：{{ lclInfo.lclInfo.F_SpellState === '1' ? '直拼' : '中转' }}</p>
        <p v-if="lclInfo.lclInfo.F_SpellState !== '1'">中转港：{{ lclInfo.lclInfo.TransitPortEnglish || '--' }}</p>
        <p>班期：{{ lclInfo.lclInfo.F_ShiftPeriod }}</p>
        <p>截单时间：{{ lclInfo.lclInfo.F_CutoffTime }}</p>
        <p>截货时间：{{ lclInfo.lclInfo.F_CutoffGoodsTime }}</p>
        <p v-for="(value, index) in lclInfo.lclInfo.Efw_WarehouseArr" :key="index">接货仓库：{{ value.F_WarehouseName }}</p>
        <p>订舱备注：{{ lclInfo.lclInfo.F_BookingRemarks }}</p>
        <p>费用备注：{{ lclInfo.lclInfo.F_ExpenseNote }}</p>
      </div>

      <div class="lcltext-item">
        <p>海运费及附加费</p>
        <div v-for="(value, index) in lclInfo.freightArr" :key="index">
          <p>费用名称：{{ value. F_ExpenseCodeName? value. F_ExpenseCodeName : '--' }}{{ value.F_ExpenseCodeEng? '(' + value.F_ExpenseCodeEng + ')' : '' }}</p>
          <p>币种：{{ value.F_Currency? value.F_Currency : '--' }}</p>
          <p>CBM：{{ value.F_CBM? value.F_CBM > 0 ? value.F_CBM : '(' + value.F_CBM * -1 + ')' : '--' }}</p>
          <p>TON：{{ value.F_TON? value.F_TON > 0 ? value.F_TON : '(' + value.F_TON * -1 + ')' : '--' }}</p>
          <p v-if="value.F_MIN">MIN：{{ value.F_MIN? value.F_MIN > 0 ? value.F_MIN : '(' + value.F_MIN * -1 + ')' : '--' }}</p>
          <p v-if="value.F_RT">RT范围：{{ value.F_RT? value.F_RT : '--' }}</p>
          <p v-if="value.F_VolumeRatio">体积比：{{ value.F_VolumeRatio? '1 :' + value.F_VolumeRatio : '--' }}</p>
          <p v-if="value.F_PaymentMethod">付款方式：{{ value.F_PaymentMethod? value.F_PaymentMethod : '--' }}</p>
          <p v-if="value.F_Remark">备注：{{ value.F_Remark? value.F_Remark : '--' }}</p>
        </div>
      </div>

      <!-- 起运港费用 -->
      <div class="lcltext-item">
        <p>起运港费用</p>
        <div v-for="(value, index) in lclInfo.polFee" :key="index">
          <p>费用名称：{{ value.F_ExpenseCodeName? value.F_ExpenseCodeName : '--' }}{{ value.F_ExpenseCodeEng? '(' + value.F_ExpenseCodeEng + ')' : '' }}</p>
          <p>币种：{{ value.F_Currency? value.F_Currency : '--' }}</p>
          <p>费用：{{ value.F_UnitPrice? value.F_UnitPrice : '--' }}</p>
          <p>单位：{{ value.F_Unit? value.F_Unit : '--' }}</p>
          <p v-if="value.F_Remark">备注：{{ value.F_Remark? value.F_Remark : '--' }}</p>
        </div>
        <p v-if="lclInfo.textareaPol">{{ lclInfo.textareaPol || '--' }}</p>
      </div>


      <div class="lcltext-item">
        <p>目的港费用</p>
        <div v-for="(value, index) in lclInfo.podFee" :key="index">
          <p>费用名称：{{ value.F_ExpenseCodeName? value.F_ExpenseCodeName : '--' }}{{ value.F_ExpenseCodeEng? '(' + value.F_ExpenseCodeEng + ')' : '' }}</p>
          <p>币种：{{ value.F_Currency? value.F_Currency : '--' }}</p>
          <p>费用：{{ value.F_UnitPrice? value.F_UnitPrice : '--' }}</p>
          <p>单位：{{ value.F_Unit? value.F_Unit : '--' }}</p>
          <p>最低费用：{{ value.F_MinPrice? value.F_MinPrice : '--' }}</p>
          <p>最高费用：{{ value.F_MaxPrice? value.F_MaxPrice : '--' }}</p>
          <p v-if="value.F_IntervalMaxPrice">区间：{{ value.F_IntervalMaxPrice? value.F_IntervalMaxPrice : '--' }}</p>
          <p>体积比：{{ value.F_VolumeRatio? value.F_VolumeRatio : '--' }}</p>
          <p v-if="value.F_Remark">备注：{{ value.F_Remark? value.F_Remark : '--' }}</p>
        </div>
        <p v-if="lclInfo.textareaPod">{{ lclInfo.textareaPod }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LclText',
  data() {
    return {
      lclInfo: {
        lclInfo: {},
        freight: [],
        polFee: [],
        podFee: []
      },
      copyText: ''
    }
  },

  mounted() {
    setTimeout(() => {
      this.lclInfo = window.sessionStorage.getItem("stand") ? JSON.parse(window.sessionStorage.getItem("stand")) : {
        lclInfo: {},
        freight: [],
        polFee: [],
        podFee: []
      }
    }, 1000)
  },

  methods: {
    copyTextEvent() {
      // 手动构建文本内容
      let text = ''
      const info = this.lclInfo.lclInfo
      
      // 基本信息
      text += '业务类型：海出拼箱\n'
      text += `船公司：${info.F_ShoppingCompany || '--'}\n`
      text += `起运港：${info.FromPortName || ''} ${info.FromPortEnglish || ''}\n`
      text += `目的港：${info.ToPortName || ''} ${info.ToPortEnglish || ''}\n`
      text += `航程：${info.F_Voyage || ''}\n`
      text += `收货人：${info.ConsigneeTypeName || ''}\n`
      text += `运输方式：${info.F_SpellState === '1' ? '直拼' : '中转'}\n`
      if (info.F_SpellState !== '1') {
        text += `中转港：${info.TransitPortEnglish || '--'}\n`
      }
      text += `班期：${info.F_ShiftPeriod || ''}\n`
      text += `截单时间：${info.F_CutoffTime || ''}\n`
      text += `截货时间：${info.F_CutoffGoodsTime || ''}\n`
      if (info.Efw_WarehouseArr && info.Efw_WarehouseArr.length > 0) {
        info.Efw_WarehouseArr.forEach(item => {
          text += `接货仓库：${item.F_WarehouseName || ''}\n`
        })
      }
      text += `订舱备注：${info.F_BookingRemarks || ''}\n`
      text += `费用备注：${info.F_ExpenseNote || ''}\n`
      
      // 海运费及附加费
      text += '\n海运费及附加费\n'
      if (this.lclInfo.freightArr && this.lclInfo.freightArr.length > 0) {
        this.lclInfo.freightArr.forEach(item => {
          text += `费用名称：${item.F_ExpenseCodeName || '--'}${item.F_ExpenseCodeEng ? '(' + item.F_ExpenseCodeEng + ')' : ''}\n`
          text += `币种：${item.F_Currency || '--'}\n`
          text += `CBM：${item.F_CBM ? (item.F_CBM > 0 ? item.F_CBM : '(' + item.F_CBM * -1 + ')') : '--'}\n`
          text += `TON：${item.F_TON ? (item.F_TON > 0 ? item.F_TON : '(' + item.F_TON * -1 + ')') : '--'}\n`
          if (item.F_MIN) {
            text += `MIN：${item.F_MIN > 0 ? item.F_MIN : '(' + item.F_MIN * -1 + ')'}\n`
          }
          if (item.F_RT) {
            text += `RT范围：${item.F_RT}\n`
          }
          if (item.F_VolumeRatio) {
            text += `体积比：${item.F_VolumeRatio}\n`
          }
          if (item.F_PaymentMethod) {
            text += `付款方式：${item.F_PaymentMethod}\n`
          }
          if (item.F_Remark) {
            text += `备注：${item.F_Remark}\n`
          }
        })
      }
      
      // 起运港费用
      text += '\n起运港费用\n'
      if (this.lclInfo.polFee && this.lclInfo.polFee.length > 0) {
        this.lclInfo.polFee.forEach(item => {
          text += `费用名称：${item.F_ExpenseCodeName || '--'}${item.F_ExpenseCodeEng ? '(' + item.F_ExpenseCodeEng + ')' : ''}\n`
          text += `币种：${item.F_Currency || '--'}\n`
          text += `费用：${item.F_UnitPrice || '--'}\n`
          text += `单位：${item.F_Unit || '--'}\n`
          if (item.F_Remark) {
            text += `备注：${item.F_Remark}\n`
          }
        })
      }
      if (this.lclInfo.textareaPol) {
        text += `${this.lclInfo.textareaPol}\n`
      }
      
      // 目的港费用
      text += '\n目的港费用\n'
      if (this.lclInfo.podFee && this.lclInfo.podFee.length > 0) {
        this.lclInfo.podFee.forEach(item => {
          text += `费用名称：${item.F_ExpenseCodeName || '--'}${item.F_ExpenseCodeEng ? '(' + item.F_ExpenseCodeEng + ')' : ''}\n`
          text += `币种：${item.F_Currency || '--'}\n`
          text += `费用：${item.F_UnitPrice || '--'}\n`
          text += `单位：${item.F_Unit || '--'}\n`
          text += `最低费用：${item.F_MinPrice || '--'}\n`
          text += `最高费用：${item.F_MaxPrice || '--'}\n`
          if (item.F_IntervalMaxPrice) {
            text += `区间：${item.F_IntervalMaxPrice}\n`
          }
          text += `体积比：${item.F_VolumeRatio || '--'}\n`
          if (item.F_Remark) {
            text += `备注：${item.F_Remark}\n`
          }
        })
      }
      if (this.lclInfo.textareaPod) {
        text += `${this.lclInfo.textareaPod}\n`
      }
      
      // 使用Clipboard API复制文本
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.fallbackCopy(text)
        })
      } else {
        // 降级方案：使用textarea方式
        this.fallbackCopy(text)
      }
    },
    
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      
      try {
        document.execCommand('copy')
        this.$message.success('复制成功')
      } catch (err) {
        this.$message.error('复制失败')
      }
      
      document.body.removeChild(textarea)
    }
  }

}
</script>
<style scoped>
.lcltext {
  position: relative;
  width: 750px;
  background: #fff;
  margin: 0 auto;
  padding: 24px;

  .copy-text-btn {
    position: absolute;
    right: 12px;
    top: 12px;
  }

  .lcltext-item {
    margin-bottom: 20px;

    p {
      font-size: 14px;
      color: #555;
      margin: 0;
      line-height: 1.8;
    }

    p.title {
      margin-bottom: 10px;
      padding-top: 5px;
    }
  }
}
</style>